export enum UserPermission {
  CREATE_PD_SESSION = 'pdCreateSession',
  PD_FACILITATOR = 'pdFacilitator',
  ENDORSE_RESOURCES = 'endorseResources',
}

export interface UserAssignedPermissionDTO {
  pdCreateSession: number;
  pdFacilitator: number;
  endorseResources: number;
}
